import classnames from 'classnames2';
import React from 'react';
import styles from './Icon.scss';
import { IconSVGs } from './IconSVGs';
export var Icon = function Icon(props) {
  var _props$ariaHidden = props.ariaHidden,
      ariaHidden = _props$ariaHidden === void 0 ? false : _props$ariaHidden,
      ariaLabel = props.ariaLabel,
      _props$ariaLabelledby = props.ariaLabelledby,
      ariaLabelledby = _props$ariaLabelledby === void 0 ? null : _props$ariaLabelledby,
      _props$className = props.className,
      className = _props$className === void 0 ? '' : _props$className,
      icon = props.icon,
      _props$dataTest = props.dataTest,
      dataTest = _props$dataTest === void 0 ? '' : _props$dataTest;
  var IconName = IconSVGs[icon];
  return React.createElement(IconName, {
    "aria-hidden": ariaHidden,
    "aria-labelledby": ariaLabelledby,
    ariaLabel: ariaLabel,
    className: classnames(styles.base, className),
    "data-test": dataTest,
    focusable: "false"
  });
};